<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="onConfirm"
  >
    <v-card-text class="mt-2">
      Är du säker på att du vill ta bort prognosen:
      <strong>{{ item.name }}</strong
      >?
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer />
      <v-btn rounded @click="closeModal">Avbryt</v-btn>
      <v-btn rounded type="submit" color="error" :loading="pending"
        >Ta bort</v-btn
      >
    </v-card-actions>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'MasterdataForecastDeleteModal',

  props: {
    refetch: Function,
    item: Object
  },

  data: () => ({
    valid: true,
    pending: false
  }),

  methods: {
    async onConfirm() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return

      this.pending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: DeleteForecastInput!) {
            deleteForecast(payload: $payload) {
              deleted_forecast_uuid
            }
          }
        `,
        variables: {
          payload: {
            uuid: this.item.uuid
          }
        }
      })

      this.pending = false
      this.refetch()
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
    }
  }
}
</script>
